
import { useEffect } from 'react';
import '@xyflow/react/dist/style.css';

// Import our custom components and types
import NodeExplorer from './NodeExplorer';
import AnimatedSection from './AnimatedSection';
import { initialNodes, initialEdges } from './workflow/initialData';
import WorkflowCanvas from './workflow/WorkflowCanvas';
import DemoDisclaimer from './workflow/DemoDisclaimer';

// Import custom hooks
import { useWorkflowAnimation } from '../hooks/useWorkflowAnimation';
import { useWorkflowSetup } from '../hooks/useWorkflowSetup';

const WorkflowVisualization = () => {
  // Set up workflow animation and state
  const {
    nodes,
    edges,
    onNodesChange,
    onEdgesChange,
    setNodes,
    setEdges
  } = useWorkflowAnimation(initialNodes, initialEdges);

  // Set up workflow interaction handlers
  const {
    handleNodeSelect,
    onConnect,
    onDrop,
    onDragOver
  } = useWorkflowSetup(setEdges, setNodes);

  return (
    <section className="py-12 bg-neutral-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <AnimatedSection className="text-center mb-8">
          <h2 className="text-2xl font-display font-bold tracking-tight">
            Visual No-Code Workflow Builder
          </h2>
          <p className="mt-3 text-neutral-600 max-w-2xl mx-auto">
            Design sophisticated Bayesian analyses by connecting data operations in our intuitive visual interface
          </p>
        </AnimatedSection>
      
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <div className="md:col-span-1 h-[460px]">
            <NodeExplorer onNodeSelect={handleNodeSelect} />
          </div>
          <div className="md:col-span-3 h-[460px]">
            <WorkflowCanvas
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onDrop={onDrop}
              onDragOver={onDragOver}
            />
          </div>
        </div>
        
        <DemoDisclaimer />
      </div>
    </section>
  );
};

export default WorkflowVisualization;
